import axios from 'axios';

/**
 * Newsletter service for handling email subscriptions
 */
export class NewsletterService {
    static async subscribe(email) {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/newsletter/subscribe`, {
            email: email.trim()
        });
        return response.data;
    }

    static validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    static formatErrorMessage(error) {
        if (error.response) {
            const errorMessage = error.response.data?.message || "Server error occurred.";
            if (error.response.status === 400) {
                if (errorMessage.includes("already subscribed")) {
                    return {
                        type: 'info',
                        message: "ℹ️ You're already subscribed to our newsletter!"
                    };
                } else {
                    return {
                        type: 'error',
                        message: `❌ ${errorMessage}`
                    };
                }
            } else {
                return {
                    type: 'error',
                    message: "❌ Server error. Please try again later."
                };
            }
        } else if (error.request) {
            return {
                type: 'error',
                message: "❌ Network error. Please check your connection."
            };
        } else {
            return {
                type: 'error',
                message: "❌ An unexpected error occurred."
            };
        }
    }
}

export default NewsletterService;